<template>
    <div class="financialoperation">
        <PageTitle
            icon="fa fa-search"
            main="Controle"
            sub="Operações Mensais"
        />
        <b-row class="mt-2">
            <b-col md="4" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="release-search-company_id"
                >
                    <b-form-select
                        id="release-search-company_id"
                        @input=";[loadReleases()]"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Ano:"
                    label-for="release-search-settlement_value"
                >
                    <b-form-input
                        id="release-search-settlement_value"
                        v-model="year"
                        type="number"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Realizado:"
                    label-for="release-search-closed"
                >
                    <b-form-select
                        id="release-search-closed"
                        size="sm"
                        @input=";[loadReleases()]"
                        :options="questionboxyesnoalls"
                        v-model="closed"
                    />
                </b-form-group>
            </b-col>
            <b-col md="1" sm="12">
                <b-link
                    @click=";[loadReleases()]"
                    class="fa fa-search mt-4"
                ></b-link>
            </b-col>
        </b-row>
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Despesas" active>
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    v-show="showTable"
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    striped
                                    :items="payments"
                                    :fields="fieldsPayment"
                                >
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Receitas">
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    v-show="showTable"
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    striped
                                    :items="receipts"
                                    :fields="fieldsReceipt"
                                >
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Transição"> </b-tab>
            </b-tabs>
        </b-card>
        <hr />
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'FinancialOperationSearch',
    components: { PageTitle },
    data: function() {
        return {
            financialoperations: [],
            total_plot_closed: 0,
            total_plot_open: 0,
            total_plot: 0,
            closed: null,
            year: null,
            company_id: null,
            companys: [],
            payments: [],
            receipts: [],
            questionboxyesnoalls: [
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 2 }
            ],
            showTable: false,
            fieldsPayment: [
                {
                    key: 'name_operation_level_two',
                    label: 'Sub-Operação',
                    sortable: false
                },
                {
                    key: 'value_1',
                    label: 'Janeiro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_2',
                    label: 'Fevereiro',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_3',
                    label: 'Março',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_4',
                    label: 'Abril',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_5',
                    label: 'Maio',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_6',
                    label: 'Junho',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_7',
                    label: 'Julho',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_8',
                    label: 'Agosto',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_9',
                    label: 'Setembro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_10',
                    label: 'Outubro',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_11',
                    label: 'Novembro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_12',
                    label: 'Dezembro',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_total',
                    label: 'Total',
                    sortable: false,
                    variant: 'dark',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                }
            ],
            fieldsReceipt: [
                {
                    key: 'name_operation_level_two',
                    label: 'Sub-Operação',
                    sortable: false
                },
                {
                    key: 'value_1',
                    label: 'Janeiro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_2',
                    label: 'Fevereiro',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_3',
                    label: 'Março',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_4',
                    label: 'Abril',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_5',
                    label: 'Maio',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_6',
                    label: 'Junho',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_7',
                    label: 'Julho',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_8',
                    label: 'Agosto',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_9',
                    label: 'Setembro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_10',
                    label: 'Outubro',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'value_11',
                    label: 'Novembro',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                { key: 'value_12', label: 'Dezembro', sortable: false },
                {
                    key: 'value_total',
                    label: 'Total',
                    sortable: false,
                    variant: 'dark',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                }
            ]
        }
    },
    computed: {
        compan() {
            return this.$store.state.compan
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        }
    },
    methods: {
        loadReleases() {
            const url_payment = `${baseApiUrl}/financialoperationpayment/?year=${this.year}&company_id=${this.company_id}`
            axios.get(url_payment).then(res => {
                this.payments = res.data[0]
            })

            const url_receipt = `${baseApiUrl}/financialoperationreceipt/?year=${this.year}&company_id=${this.company_id}`
            axios.get(url_receipt).then(res => {
                this.receipts = res.data[0]
            })
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        }
    },
    mounted() {
        this.loadCompanys()
        //this.loadReleases()
        this.showTable = true
        let date = new Date()
        let get_year = date.getFullYear()
        this.year = get_year
    }
}
</script>

<style>
.financialoperation {
    font-size: 0.7rem;
}

.financialoperation input,
label,
form {
    font-size: 0.7rem;
}
.financialoperation button {
    font-size: 0.7rem;
}

.financialoperation select {
    font-size: 0.7rem;
}

.financialoperation table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
